// Sales Portal Route Configuration
import { lazy } from 'react';

const SalesDashboard = lazy(() => import('../../portals/sales/pages/dashboard/SalesDashboard'));
const SalesClientsPage = lazy(() => import('../../portals/sales/pages/clients/SalesClientsPage'));
const BureauIntakePage = lazy(() => import('../../portals/sales/pages/bureau-intake/BureauIntakePage'));
const ActionRequestsPage = lazy(
  () => import('../../portals/sales/pages/action-requests/ActionRequestsPage')
);
const SalesStaffPage = lazy(() => import('../../portals/sales/pages/staff/SalesStaffPage'));
const DemoModePage = lazy(() => import('../../portals/sales/pages/demo/DemoModePage'));
const MySupportPage = lazy(() => import('../../shared/support/pages/MySupportPage'));

/**
 * Sales Portal Routes
 * Client-centric portal — Dashboard (aggregated) + Clients (per-client tabs)
 * Sales Staff tab visible to Account Leaders (hierarchy_level >= 1) only
 */
const salesRoutes = {
  path: '/sales',
  name: 'Sales Portal',
  description: 'Portal for sales representatives',
  requiredRoles: [],
  requiredPermissions: [],
  children: [
    {
      index: true,
      component: SalesDashboard,
      name: 'Dashboard',
      description: 'Sales dashboard overview',
      requiredPermissions: [],
      meta: {
        title: 'Sales Dashboard',
        breadcrumb: 'Dashboard',
        icon: 'dashboard',
      },
    },
    {
      path: 'clients',
      component: SalesClientsPage,
      name: 'Clients',
      description: 'Client management with per-client bureau dashboard',
      requiredPermissions: [],
      meta: {
        title: 'Sales Clients',
        breadcrumb: 'Clients',
        icon: 'business',
      },
    },
    {
      path: 'bureau-intake',
      component: BureauIntakePage,
      name: 'Bureau Intake',
      description: 'Bureau monitoring intake requests',
      requiredPermissions: [],
      meta: {
        title: 'Bureau Intake',
        breadcrumb: 'Bureau Intake',
        icon: 'inbox',
      },
    },
    {
      path: 'action-requests',
      component: ActionRequestsPage,
      name: 'Action Requests',
      description: 'Action requests and task assignments',
      requiredPermissions: [],
      meta: {
        title: 'Action Requests',
        breadcrumb: 'Action Requests',
        icon: 'assignment_turned_in',
      },
    },
    {
      path: 'staff',
      component: SalesStaffPage,
      name: 'Sales Staff',
      description: 'Team management and performance tracking',
      requiredPermissions: [],
      meta: {
        title: 'Sales Staff',
        breadcrumb: 'Staff',
        icon: 'groups',
      },
    },
    {
      path: 'demo',
      component: DemoModePage,
      name: 'Demo Mode',
      description: 'Configure and launch demo client portals for prospects',
      requiredPermissions: [],
      meta: {
        title: 'Demo Mode',
        breadcrumb: 'Demo Mode',
        icon: 'play_arrow',
      },
    },
    {
      path: 'my-support',
      component: MySupportPage,
      name: 'My Support',
      description: 'My tickets and notifications',
      requiredPermissions: [],
      meta: {
        title: 'My Support',
        breadcrumb: 'Support',
        icon: 'support_agent',
      },
    },
  ],
};

export default salesRoutes;
